export default __webpack_public_path__ + "img/support.a585a016.png";